import React from "react";
import headerDecor from "../../images/decors/header_decor.png";
import MenuDecor from "./MenuDecor";

const HeaderDecor = () => (
	<MenuDecor src={headerDecor}/>
);

export default HeaderDecor;